import DefaultTable from '../../../../common/components/table/DefaultTable';
import {useControllers} from '../../../../../../common/helpers/react/hooks/useControllers';
import {useGroupsTableColumns} from '../useGroupsTableColumns';
import {toServerSortingConfig} from '../../../../common/components/table/helpers/toServerSortingConfig';

export default function GroupsTable() {
    const groups = useControllers().groups;
    const columns = useGroupsTableColumns();
    const data = groups.getAllGroups$().useState();
    const isBusy = groups.isBusy$().useState() !== false;
    const sortingState = groups.getGroupsSortingState$().useState();

    const sorting = toServerSortingConfig(sortingState, (sortBy, sortOrder) =>
        groups.changeGroupsSorting(sortBy, sortOrder), 'name');

    return <DefaultTable
        columns={columns}
        data={data}
        isBusy={isBusy}
        sorting={sorting}
    />;
}